export const SIMPLIFIED_IT_SERVICE_MANAGEMENT_BASIC =
	'com.atlassian.servicedesk:simplified-it-service-management-basic';

export const SIMPLIFIED_IT_SERVICE_MANAGEMENT_ADVANCED =
	'com.atlassian.servicedesk:simplified-it-service-management';

export const COMPANY_MANAGED_GENERAL_SERVICE_PROJECT =
	'com.atlassian.servicedesk:company-managed-general-service-project';

export const JIRA_POLARIS_ROADMAP = 'jira.polaris:roadmap';

export const JIRA_POLARIS_PRIORITIZATION = 'jira.polaris:prioritization';

export const JIRA_POLARIS_DISCOVERY = 'jira.polaris:discovery';
